import React from "react";
import "./App.css";

import Header from "./components/Header";

import Router from "./router/Router";
function App() {
  return (
    <>
      <Header />
      <Router />
    </>
  );
}

export default App;
